import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FoodMenu from './pages/FoodMenu';
import DrinkMenu from './pages/DrinkMenu';
import Music from './pages/Music';
import Contact from './pages/Contact';
import OurStory from './pages/OurStory';
import PrivateEvents from './pages/PrivateEvents';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/food-menu" element={<FoodMenu />} />
          <Route path="/drink-menu" element={<DrinkMenu />} />
          <Route path="/music" element={<Music />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/private-events" element={<PrivateEvents />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
